const imageErrorHandler = function () {
    document.body.addEventListener('error',
                                   (event) => {
                                       if (event.target.tagName.toLowerCase() == 'img') {
                                           event.target.src = '/fe-resources/images/no-image.gif';
                                       }
                                   }, true);
};

export default imageErrorHandler;